import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AngularMenuComponent } from './angular-menu.component';


@NgModule({
    imports: [CommonModule],
    declarations: [AngularMenuComponent],
    exports: [AngularMenuComponent],
    providers: []
})
export class AngularMenuModule { }


// WEBPACK FOOTER //
// ./src/angular_library/components/menu/angular-menu.module.ts